/**
 * Constants for SVG floor plan layer IDs.
 */

// --- SVG Group IDs ---

/** Prefix for Strand-style option code layers (e.g. `OPT_CODE_ABC123`) */
export const OPT_CODE_PREFIX = "OPT_CODE_";

/** Prefix for HB-created option code layers (e.g. `OPTION-CODE-ABC123`) */
export const OPTION_CODE_PREFIX = "OPTION-CODE-";

// Floor plan layers
export const FLOORPLAN_STANDARD = "FLOORPLAN_STANDARD";
export const FLOORPLAN_FLIP = "FLOORPLAN_FLIP";
export const FLOORPLAN_CAD = "FLOORPLAN_CAD";
export const FIRST_FLOOR_LABEL = "1st_floor_label";
export const SECOND_FLOOR_LABEL = "2nd_floor_label";

// Dimension layers
export const DIMENSIONS_STANDARD = "DIMENSIONS_STANDARD";
export const DIMENSIONS_FLIP = "DIMENSIONS_FLIP";

// Room name layers
export const ROOMNAMES_STANDARD = "ROOMNAMES_STANDARD";
export const ROOMNAMES_FLIP = "ROOMNAMES_FLIP";

// Meta / decorative layers
export const PLAN_TEXT = "PLAN_TEXT";
export const LOGO = "LOGO";

// Base geometry layer identifier (used in Eaton Fire image-based SVGs)
export const BASE_GEOMETRY = "BASE_GEOMETRY";

// Highlight sub-group (case-insensitive in queries)
export const HIGHLIGHT = "highlight";

// --- Selector helpers ---

/** Exact-match `<g>` selector: `g[id="FLOORPLAN_STANDARD"]` */
export const gId = (id: string) => `g[id="${id}"]` as const;

/** Case-insensitive contains-match `<g>` selector: `g[id="highlight" i]` */
export const gIdCaseInsensitive = (id: string) => `g[id="${id}" i]` as const;

/** Case insensitive Contains-match `<g>` selector: `g[id*="OPT_CODE_"]` */
export const gIdContains = (id: string) => `g[id*="${id}" i]` as const;
